module.exports = __webpack_public_path__ + "img/dashboard-store-sleep.44e11a94.svg";